// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment as Environments, toEnvironment } from '@imaginelearning/web-auth';
import devConfig from './config.development';
import testConfig from './config.test';
import rcConfig from './config.rc';
import prodConfig from './config.production';
class EnvironmentImpl {
    constructor() {
        const windowEnv = window?.['IL_PORTAL_ENV']?.name;
        const env = windowEnv ?? 'production';
        this.production = env === 'production';
        this.environment = toEnvironment(env);
        let name = '';
        let config;
        switch (this.environment) {
            case Environments.Test:
                name = 'test';
                config = { ...devConfig, ...testConfig };
                break;
            case Environments.Rc:
                name = 'rc';
                config = { ...devConfig, ...rcConfig };
                break;
            case Environments.Production:
                name = 'production';
                config = { ...devConfig, ...prodConfig };
                break;
            default:
                name = 'development';
                config = devConfig;
                break;
        }
        this.config = config;
        this.setPortalEnv(env);
    }
    setPortalEnv(env) {
        let name;
        switch (env) {
            case 'test':
            case 'rc':
                name = env;
                break;
            case 'production':
            case 'prod':
                name = 'production';
                break;
            default:
                name = 'development';
                break;
        }
        window['IL_PORTAL_ENV'] = { ...(window['IL_PORTAL_ENV'] || {}), name };
    }
}
export default EnvironmentImpl;
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
